import React, { useState } from "react";

const OptionToggler = ({
  name,
  options,
  defaultValue,
  onSelectFn,
  disabled = false,
}) => {
  const [selectedOption, setSelectedOption] = useState(defaultValue);

  const handleOptionChange = (value) => {
    if (onSelectFn) {
      onSelectFn(value);
    }
    setSelectedOption(value);
  };

  return (
    <div className="option-toggler">
      {options.map((option, index) => (
        <label
          key={index}
          className={selectedOption === option.value ? "active" : ""}
        >
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={selectedOption === option.value}
            onChange={() => handleOptionChange(option.value)}
            disabled={disabled}
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  );
};

export default OptionToggler;
